import { MarkdownTextPrimitive } from '@assistant-ui/react-markdown';

import { cn } from '@accio3d/design-system/utils';

export const AGENT_MARKDOWN_CLASSNAME = cn(
  // Paragraphs and spacing between blocks.
  '[&>*]:my-0 [&>*+*]:mt-2',

  // Lists: the Preflight reset is what made these look wrong.
  '[&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5',
  '[&_li]:my-0.5 [&_li>ul]:mt-1 [&_li>ol]:mt-1 [&_li>p]:my-0',

  // Headings: Preflight strips their size and weight.
  '[&_h1]:text-sm [&_h1]:font-semibold [&_h2]:text-sm [&_h2]:font-semibold',
  '[&_h3]:text-xs [&_h3]:font-semibold [&_h3]:uppercase [&_h3]:tracking-wide',

  // Inline emphasis. Bold and italic are CommonMark, so they only needed a renderer,
  // but `strong` is pinned explicitly so a future Preflight change cannot flatten it.
  '[&_strong]:font-semibold [&_em]:italic',

  // Code, links, quotes and rules.
  '[&_code]:rounded [&_code]:bg-muted [&_code]:px-1 [&_code]:py-0.5 [&_code]:text-[0.85em]',
  '[&_pre]:overflow-x-auto [&_pre]:rounded [&_pre]:bg-muted [&_pre]:p-2 [&_pre]:text-xs',
  '[&_pre_code]:bg-transparent [&_pre_code]:p-0',
  '[&_a]:underline [&_a]:underline-offset-2 hover:[&_a]:text-primary',
  '[&_blockquote]:border-l-2 [&_blockquote]:border-border [&_blockquote]:pl-2 [&_blockquote]:text-muted-foreground',
  '[&_hr]:my-3 [&_hr]:border-border',

  // Long part numbers and refs must not widen the 380px panel.
  'break-words',
);

/* Strips the citations the graph appends, without touching anything else */
export function stripSourceRefs(text: string): string {
  return (
    text
      .replace(/[ \t]*[([][ \t]*see:[^)\]]*[)\]][ \t]*(?=[.,;:!?]|$)/gim, '')
      .replace(/[ \t]*[([][ \t]*see:[^)\]]*[)\]][ \t]*/gi, ' ')

      // A bare "Source: nav/action/open_part" line, and the line it occupied.
      .replace(/^[ \t]*source:[ \t]*\S+[ \t]*$/gim, '')

      .replace(/\n{3,}/g, '\n\n')
      .trimEnd()
  );
}

export function AgentMarkdownText() {
  return (
    <MarkdownTextPrimitive
      smooth={false}
      preprocess={stripSourceRefs}
      className={AGENT_MARKDOWN_CLASSNAME}
    />
  );
}
